export const mutations = {
  STORE_TRUCK_ATTENDANCES(state, truckattendances) {
    state.truckattendances = truckattendances;
  },
  STORE_TRUCK_ATTENDANCE_UPDATE(state, truckattendanceId) {
    let Truckattendance = state.truckattendances.find(function(
      truckattendance
    ) {
      return truckattendance.id === truckattendanceId;
    });
    state.systemTruckattendance = Truckattendance;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/truckattendances/mutations.js